/** Heading, empty state, and linker controls on the meme-detail memeplex strip. */
export const memeplexPanelCopy = {
  heading: 'Memeplex',
  descendedFrom: 'Descended from',
  originalLabel: ' (the original)',
  empty: 'No relatives yet — remix this meme or link related ones.',
  link: 'Link',
  picker: 'Link a meme from your binder',
  pickerPlaceholder: 'Link from your binder…',
  pasted: 'Paste a meme link',
  pastedPlaceholder: '…or paste a meme link',
} as const
